import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCarrotIconMain = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 77,
	height: 77,
	viewBox: "0 0 77 77",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M41.9329 61.4291L45.4892 58.552L39.534 58.6671L32.1489 50.1828L37.6946 46.3151L29.7786 47.3107L21.7565 38.3032L29.3787 34.0823L20.1772 35.9687L13.8539 28.875L54.7842 18.4814V29.8576L46.179 34.9153L54.7842 33.7216V46.7393L50.3453 49.6228L54.7842 49.4862V59.5917L51.7707 62.2116L54.7842 62.4512C54.7842 70.989 54.7024 75.5249 54.5388 76.059C53.4546 77.3939 41.9329 61.4291 41.9329 61.4291Z",
		fill: "#F7931E"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M38.9437 1C39.8683 1 35.3976 7.45542 36.1631 12.8182C39.1186 10.6603 42.4347 7.08574 47.7706 7.08574C50.1703 7.08574 44.5608 9.91734 42.2924 12.8182C39.6217 16.2334 39.3387 20.4969 39.1144 20.5562C37.0755 21.0952 31.3538 22.6816 29.4069 23.088C28.7244 23.2305 28.945 21.7181 28.2757 20.7407C27.6064 19.7634 13.9746 11.9463 16.5337 11.286C19.74 10.4587 25.4474 13.2547 29.5876 14.1226C31.1004 7.08574 35.8724 1 38.9437 1Z",
		fill: "#04C4AE"
	})]
});
export default SvgCarrotIconMain;
